import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { SiteHeader } from '../../components/layout/SiteHeader';
import { Button } from '../../components/ui/Button';
import { Input, Label } from '../../components/ui/Input';
import { authClient } from '../../auth/client';
import { t } from '../../i18n';
import './auth-page.css';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  if (!token) {
    return (
      <div className="page-shell">
        <SiteHeader />
        <div className="centered-page">
          <div className="auth-card">
            <h1>{t('auth.resetPassword.title')}</h1>
            <div className="auth-error">{t('auth.resetPassword.invalidToken')}</div>
            <div className="auth-footer">
              <Link to="/wachtwoord-vergeten">{t('auth.forgotPassword.title')}</Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError(t('auth.resetPassword.mismatch'));
      return;
    }
    if (password.length < 8) {
      setError(t('auth.errors.weakPassword'));
      return;
    }
    setSubmitting(true);
    setError(null);
    const result = await authClient.resetPassword(token, password);
    setSubmitting(false);
    if (result.ok) {
      setSuccess(true);
    } else {
      setError(result.offline ? t('auth.errors.network') : t('auth.errors.generic'));
    }
  };

  return (
    <div className="page-shell">
      <SiteHeader />
      <div className="centered-page">
        <div className="auth-card">
          <h1>{t('auth.resetPassword.title')}</h1>
          <p className="auth-card-subtitle">{t('auth.resetPassword.subtitle')}</p>

          {success ? <div className="auth-success">{t('auth.resetPassword.success')}</div> : null}
          {error ? <div className="auth-error">{error}</div> : null}

          {!success ? (
            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="field-group">
                <Label htmlFor="password">{t('auth.resetPassword.password')}</Label>
                <Input
                  id="password"
                  type="password"
                  autoComplete="new-password"
                  required
                  minLength={8}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div className="field-group">
                <Label htmlFor="confirmPassword">{t('auth.resetPassword.confirmPassword')}</Label>
                <Input
                  id="confirmPassword"
                  type="password"
                  autoComplete="new-password"
                  required
                  minLength={8}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
              <Button type="submit" variant="primary" size="lg" disabled={submitting}>
                {submitting ? t('common.loading') : t('auth.resetPassword.submit')}
              </Button>
            </form>
          ) : (
            <Button asChild variant="primary" size="lg">
              <Link to="/login">{t('nav.login')}</Link>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
